import { GET_GROUPS_PHASE } from '../types/groups.types';

const initState = {
  standings: [],
};

export default (state = initState, action) => {
  switch (action.type) {
    case GET_GROUPS_PHASE:
      return {
        ...state,
        standings: action.payload,
      };

    default:
      return state;
  }
};
